import { EventEmitter, Injectable, Output } from '@angular/core';
import { PdfInstanceManagerService } from './instance/pdf-instance-manager.service';
import { TabService } from './tab.service';
import { DocumentManagerService } from './document/document-manager.service';
import { AsgardDocPdf } from '../core/documents/asgard-doc-pdf';
import { WebViewerInstance } from '@pdftron/webviewer';


interface PDFCoords {
  x1: number;
  y1: number;
  x2: number;
  y2: number;
}


@Injectable({
  providedIn: 'root'
})
export class RectangleSelectionService {
  @Output() MouseUpEvent: EventEmitter<PDFCoords> = new EventEmitter();

  private get currentDoc(): AsgardDocPdf | null {
    const doc = this.docMgrSvc.currentDoc;
    if (doc) {
      if (doc instanceof AsgardDocPdf) {
        return doc;
      }
    }
    return null;
  }

  private instance: WebViewerInstance | null = null;
  private pdfCoords: PDFCoords = { x1: 0, y1: 0, x2: 0, y2: 0 };
  private isEnabled: boolean = false;

  private downListener: null | any = null;
  private upListener: null | any = null;

  constructor(
    private pdfManager: PdfInstanceManagerService,
    private tabSvc: TabService,
    private docMgrSvc: DocumentManagerService
  ) {
  }

  public toggleRectSelect(): void {
    if (this.tabSvc.activeTab) {
      this.instance = this.pdfManager.getViewerInstance(this.tabSvc.activeTab.id);
      this.isEnabled = !this.isEnabled;
      this.isEnabled ? this.enableScreenshotMode() : this.disableScreenshotMode();
    }
  }

  private disableScreenshotMode(): void {
    this.isEnabled = false;

    this.changeCursor('');
    if (this.instance) {
      this.instance.Core.documentViewer.getScrollViewElement().removeEventListener('mousedown', this.downListener);
      this.instance.Core.documentViewer.getScrollViewElement().removeEventListener('mouseup', this.upListener);
    }

  }

  private enableScreenshotMode(): void {
    this.isEnabled = true;

    this.changeCursor('crosshair');
    // attach bound functions to variable or they won't be removed.
    this.downListener = this.mouseDownListener.bind(this);
    this.upListener = this.mouseUpListener.bind(this);
    if (this.instance) {
      this.instance.Core.documentViewer.getScrollViewElement().addEventListener('mousedown', this.downListener);
      this.instance.Core.documentViewer.getScrollViewElement().addEventListener('mouseup', this.upListener);
    }
  }

  private changeCursor(cursor: string): void {
    if (this.currentDoc) {
      const iframe = this.currentDoc.editorElement as HTMLIFrameElement;
      // Every page element needs cursor change
      if (iframe && iframe.contentDocument) {
        const ids = iframe.contentDocument.querySelectorAll('[id^=\'pageWidgetContainer\']');
        ids.forEach((el) => {
          const element = el as HTMLElement;
          element.style.cursor = cursor;
        });
      }
    }
  }

  private mouseDownListener(evt: MouseEvent): void {
    this.getCoords(evt);
  }

  private mouseUpListener(evt: MouseEvent): void {
    this.getCoords(evt);
    if (this.pdfCoords.x1 === this.pdfCoords.x2 && this.pdfCoords.y1 === this.pdfCoords.y2) {
      return;
    }
    this.MouseUpEvent.emit(this.pdfCoords);
  }

  private getCoords(evt: MouseEvent): void {
    if (this.currentDoc) {
      const coords = this.currentDoc.convertMouseCoordsIntoPdfCoords(evt);
      if (coords) {
        if (evt.type === 'mousedown') {
          this.pdfCoords.x1 = coords.clientX;
          this.pdfCoords.y1 = coords.clientY;
        } else if (evt.type === 'mouseup') {
          this.pdfCoords.x2 = coords.clientX;
          this.pdfCoords.y2 = coords.clientY;
          this.disableScreenshotMode();
        }
      }
    }
  }
}

